/* eslint-disable no-magic-numbers */
export enum Viewability {
  high = 70,
  mid = 60,
  low = 50
}
